module.exports = __webpack_public_path__ + "static/media/customer-insights.743c347b.svg";